import type { HelpFile } from '../../types/help'
import { SapHcmInboundConfigCardTestIds } from '../../../testids/SapHcmInboundConfigCardTestIds'

export const sapHcmInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-hcm-connector',
  texts: {
    [SapHcmInboundConfigCardTestIds.sapHcmConfigSection]:
      'OData V2 inbound connector for SAP HCM. Reads employee master data per infotype, applies validity-band resolution, and emits joiner/leaver lifecycle events when STAT2 transitions cross the configured termination boundary.',
    [SapHcmInboundConfigCardTestIds.cardTitleSapHcmConfig]: null,
    [SapHcmInboundConfigCardTestIds.btnEditSapHcmConfig]: null,
    [SapHcmInboundConfigCardTestIds.textSapHcmEmployeeKeyField]:
      'Wire field carrying the per-employee key used to fetch infotype bands. Canonical SAP HCM is PERNR. Set to whatever name your wire format gives the employee identifier (e.g. mitarbeiterNummer in a German HR wrapper).',
  },
}
